import { useOrganizationSlug } from "pages/intake/hooks/useOrganizationSlug";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useIntakeToken, useToken } from "utils/context";
/**
 * A wrapper component that restricts access to intake routes
 * unless the user has a valid intake token or regular auth token.
 */
const IntakeRoutes = ({ children }) => {
  const { intakeToken } = useIntakeToken();
  const { accessToken } = useToken();
  const organizationSlug = useOrganizationSlug();
  const navigate = useNavigate();

  // allow access if either the intake token or regular OAuth token exists
  const isAuthorized = !!intakeToken || !!accessToken;

  useEffect(() => {
    if (!isAuthorized && organizationSlug) {
      // log to Sentry for monitoring unauthorized access attempts
      console.warn(`[SENTRY] Unauthorized intake access redirected to login`, {
        errorType: "unauthorized_intake_access",
        organizationSlug,
        hasIntakeToken: !!intakeToken,
        hasAccessToken: !!accessToken,
        currentPath: window.location.pathname,
        redirectTo: `/intake/${organizationSlug}/auth/login`,
      });

      navigate(`/intake/${organizationSlug}/auth/login`);
    }
  }, [isAuthorized, navigate, organizationSlug, intakeToken, accessToken]);

  return isAuthorized ? children : null;
};

export default IntakeRoutes;
